<template>
  <div class="table_wrap">
    <span class="total_length">총 {{ paginationData.total }}개 </span>
    <el-table :data="memberData"
              class="list-table"
              header-cell-class-name="list-header"
              empty-text="데이터가 없습니다."
              height="695"
    >
      <el-table-column
          class="table_no"
          type="index"
          label="No"
          width="90"
          class-name="num text-center"
          :index="tableIdx"
      >
      </el-table-column>
      <el-table-column
          label="탈퇴사유" width="" class-name="text-center">
        <template slot-scope="scope">
                    <span>
                        {{scope.row.mo_reason}}
                    </span>
        </template>
      </el-table-column>

        <el-table-column label="가입일" width="150" class-name="text-center">
            <template slot-scope="scope">
                    <span>
                        {{ scope.row.join_date }}
                    </span>
            </template>
        </el-table-column>

        <el-table-column label="탈퇴일" width="150" class-name="text-center">
            <template slot-scope="scope">
                    <span>
                        {{ scope.row.created_at }}
                    </span>
            </template>
        </el-table-column>
    </el-table>

  </div>
</template>

<script>
import util from "@/mixins/util";
import dateMixins from "@/mixins/dateMixins";
import alertMixins from "@/mixins/alertMixins";

export default {
  name: "MemberListQuitLayout",
  mixins: [dateMixins, alertMixins],
  components: {},
  inject: {
    setPage: {
      default: () => {
      }
    },
    memberListSetData: {
      default: () => {
      }
    },
    setFilter: {
      default: () => {
      }
    },
  },
  provide() {
    return {}
  },
  props: {
    memberData: {
      default: () => {
        return []
      }
    },
    paginationData: {
      default: () => {
        return {total: 0, page: 0, size: 0,}
      }
    },
  },
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnDate(date = null) {
      if (!date) {
        return '';
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm')
    },
    tableIdx(index) {
      return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
